// @flow
import { createAction } from 'redux-actions';
import { ADD_FORM, REMOVE_FORM } from './constants';


export const addForm = createAction(
    ADD_FORM,
    (
        code: string, executionId: string, rootCode: string, rootExecutionId: string, schema: Object,
        requestKey: ?string, initialData: ?Object, buttonLabel: ?string, title: ?string, modal: ?boolean,
    ) => ({
        code, executionId, rootCode, rootExecutionId, schema, requestKey, initialData, buttonLabel, title, modal,
    }),
);

export const removeForm = createAction(REMOVE_FORM, (code: string, executionId: string) => ({
    code, executionId,
}));
